module.exports = __webpack_public_path__ + "static/media/alcogate-2.3d85fbe6.jpg";